import IMask from 'imask';

export default class MaskFactory {
    static create(form, selector) {
        const elementsWithMask = [...form.querySelectorAll(selector)];

        return elementsWithMask.map((el) => {
            let mask = el.getAttribute('data-mask');

            if (mask.startsWith('/') && mask.endsWith('/')) {
                mask = new RegExp(mask.replace(/\//g, ''), 'g');
            }

            return IMask(el, {
                mask,
            });
        });
    }
}
